import { render, staticRenderFns } from "./ProcessStages.vue?vue&type=template&id=54e5d647&"
import script from "./ProcessStages.vue?vue&type=script&lang=js&"
export * from "./ProcessStages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports